export const APPIDS: Record<string, keyof typeof onelinkMap> = {
  M: '1233',
  T: '1180',
  LITE: '1340'
};
export const onelinkMap = {
  '1180': {
    schema: 'snssdk1180://webview',
    link: 'https://snssdk1180.onelink.me/BAuo'
  },
  '1233': {
    schema: 'snssdk1233://webview',
    link: 'https://snssdk1233.onelink.me/bIdt'
  },
  '1340': {
    schema: 'snssdk1340://webview',
    link: 'https://snssdk1340.onelink.me/k3Nj'
  }
};
export function querystringify(obj: Record<string, string | number | boolean>) {
  const pairs: string[] = [];
  let value: string;
  let key: string;

  for (key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      value = `${obj[key]}`;

      if (!value && (value === null || typeof value === 'undefined')) {
        value = '';
      }

      key = encodeURIComponent(key);
      value = encodeURIComponent(value);
      if (key === null || value === null) continue;
      pairs.push(key + '=' + value);
    }
  }

  return pairs.length ? pairs.join('&') : '';
}
export const getOneLink = (query: Record<string, string>, code: string, _lng: string, region: string, aid: keyof typeof onelinkMap, isArmor?: boolean) => {
  const ACTIVITY_URL = `${window.location.origin}${isArmor ? '/activity/armor/referral_v2_task' : '/activity/referral/task'}`;
  const config = onelinkMap[aid];
  const activityQuery: Record<string, string> = { ...query,
    enter_from: 'share',
    invite_code: code
  };

  if (region === 'br' && aid === '1340') {
    activityQuery.template = 'referral';
    activityQuery.cid = 'br_lite';
  }

  const schemaQuery = {
    url: `${ACTIVITY_URL}?${querystringify(activityQuery)}`
  };
  const onelinkQuery = {
    af_dp: `${config.schema}?${querystringify(schemaQuery)}`,
    af_web_dp: 'https://www.tiktok.com',
    c: `UG_Referral_${region.toUpperCase()}`,
    is_retargeting: 'true',
    pid: 'referral',
    af_adset: code
  };
  return `${config.link}?${querystringify(onelinkQuery)}`;
};